export var TagToken;
(function (TagToken) {
    TagToken["PARTNER_ID"] = "$PARTNER_ID$";
})(TagToken || (TagToken = {}));
